module.exports = __webpack_public_path__ + "img/Group 961t3.9c7f4637.svg";